import React, {useEffect, useState} from 'react';
import {MenuItem, Select, Typography} from '@material-ui/core';
import {
  apiGETPURCHASEORDERDELIVERYTERMS,
  apiGETPURCHASEORDERDELIVERYPREFERENCES,
} from '../utils/graph';
import {IGenericType} from 'constants/interfaces';
type DeliveryProps = {
  deliveryTerm?: IGenericType;
  deliveryPreference?: IGenericType;
  onDeliveryTerm: (term: IGenericType) => void;
  onDeliveryPreference: (preference: IGenericType) => void;
};

const Delivery = (props: DeliveryProps) => {
  const [termsOptions, setTermsOptions] = useState<Array<IGenericType>>([]);
  const [preferencesOptions, setPreferencesOptions] = useState<
    Array<IGenericType>
  >([]);
  useEffect(() => {
    apiGETPURCHASEORDERDELIVERYTERMS().then(setTermsOptions);
    apiGETPURCHASEORDERDELIVERYPREFERENCES().then((data) =>
      setPreferencesOptions(
        data.map((item) => {
          switch (Number(item.id)) {
            case 1:
              return {
                id: 1,
                name: 'Arranged by Khula',
              };
            case 2:
              return {
                id: 2,
                name: 'Arranged by Supplier',
              };
            case 3:
              return {
                id: 3,
                name: 'Arranged by Buyer',
              };
            default:
              return item;
          }
        }),
      ),
    );
  }, []);
  return (
    <div>
      <div className="title">Delivery and storage</div>
      <div className="row">
        <div className="col-6">
          <Typography>Delivery terms</Typography>
        </div>
        <div className="col-6">
          <Select
            value={props?.deliveryTerm?.id}
            placeholder="Select service"
            fullWidth
            variant="outlined"
            style={{height: 40}}
          >
            {termsOptions.map((term) => (
              <MenuItem
                key={term.id}
                value={term.id}
                onClick={() => props.onDeliveryTerm(term)}
              >
                {term.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Typography>Logistics</Typography>
        </div>
        <div className="col-6">
          <Select
            value={props?.deliveryPreference?.id}
            placeholder="Select service"
            fullWidth
            variant="outlined"
            style={{height: 40}}
          >
            {preferencesOptions.map((preference) => (
              <MenuItem
                key={preference.id}
                value={preference.id}
                onClick={() => props.onDeliveryPreference(preference)}
              >
                {preference.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default Delivery;
